'use strict';

(function (angular) {
    'use strict';

    angular.module('zp').factory('SearchModel', searchModelFactory);

    /** @ngInject */
    function searchModelFactory(GeolocationModel) {

        function SearchModel(data) {

            this.selectedDate = data && data.selectedDate ? data.selectedDate : null;
            this.selectedCategory = data && data.selectedCategory ? data.selectedCategory : null;
            this.latitude = data && data.latitude ? data.latitude : null;
            this.longitude = data && data.longitude ? data.longitude : null;
            this.city = data && data.city ? data.city : null;
        }

        return SearchModel;
    }
})(window.angular);